<script setup lang="ts">
import { computed } from 'vue'

export type AppChipVariant = 'secondary' | 'info' | 'warning' | 'success'

const props = withDefaults(defineProps<{ variant?: AppChipVariant }>(), {
  variant: 'secondary',
})

const variantClass = computed(() => `app-chip--${props.variant}`)
</script>

<template>
  <span class="app-chip" :class="variantClass">
    <slot />
  </span>
</template>
